module.exports = __webpack_public_path__ + "static/Mezze_Bites-72192491e2dac1761fbcd5b0e33d7694.png";